import PlaceImage from '../components/PlaceImage';
import React, { useState } from 'react';
import './Gallery.css';

const photos = [
  { id:1, img:"/images/destinations/coaker-s-walk.jpg", cap:"Coaker's Walk" },
  { id:2, img:"/images/destinations/kodai-lake.jpg", cap:"Kodai Lake" },
  { id:3, img:"/images/destinations/silver-cascade.jpg", cap:"Silver Cascade" },
  { id:4, img:"/images/destinations/pillar-rocks.jpg", cap:"Pillar Rocks" },
  { id:5, img:"/images/destinations/pine-forest.jpg", cap:"Pine Forest" },
  { id:6, img:"/images/destinations/dolphin-s-nose.jpg", cap:"Dolphin's Nose" },
  { id:7, img:"/images/destinations/guna-cave.jpg", cap:"Guna Cave" },
  { id:8, img:"/images/destinations/bryant-park.jpg", cap:"Bryant Park" },
  { id:9, img:"/images/destinations/bear-shola-falls.jpg", cap:"Bear Shola Falls" },
  { id:10, img:"/images/destinations/berijam-lake.jpg", cap:"Berijam Lake" },
  { id:11, img:"/images/destinations/kurinji-andavar-temple.jpg", cap:"Kurinji Andavar Temple" },
  { id:12, img:"/images/destinations/perumal-peak.jpg", cap:"Perumal Peak" }
];

export default function Gallery() {
  const [lb, setLb] = useState(null);
  return (
    <div className="gallery-page page-enter">
      <div className="inner-hero" style={{ backgroundImage: "url('/images/destinations/kodaikanal.jpg')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Memories &amp; Moments</p>
          <h1 className="display-title light">Photo Gallery</h1>
          <div className="amber-line" />
          <p>Explore Kodaikanal's lakes, waterfalls, forests and viewpoints.</p>
        </div>
      </div>

      <section className="section-pad container">
        <div className="gallery-masonry">
          {photos.map(p => (
            <div key={p.id} className="gallery-item" onClick={() => setLb(p)}>
              <PlaceImage src={p.img} alt={p.cap} loading="lazy" />
              <div className="gallery-item__overlay">
                <span>{p.cap}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {lb && (
        <div className="lightbox" onClick={() => setLb(null)}>
          <button className="lightbox__close" aria-label="Close">✕</button>
          <div className="lightbox__content" onClick={e => e.stopPropagation()}>
            <PlaceImage src={lb.img} alt={lb.cap} />
            <p>{lb.cap}</p>
          </div>
        </div>
      )}
    </div>
  );
}
